
export default function SettingsNavigation({ tabs, active, onChange }) { return <nav className="settings-tabs">{tabs.map((tab)=><button key={tab.id} type="button" className={active===tab.id?"active":""} onClick={()=>onChange(tab.id)}>{tab.label}</button>)}</nav>; }
